import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/build/repo/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/build/repo/src/components/landing/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/opt/build/repo/src/components/landing/Navbar.tsx");
